// Single source of truth for the private personal-finance module's owner.
// The module is locked to this exact email (lower-cased) — not a role, not a
// short user code (which is editable and would risk a self-lockout). The API
// route guard enforces it with a 404; the web UI hides the module the same way.
export const PERSONAL_OWNER_EMAIL = 'samuel@usenorlia.com';
